import {
  CheckButtonTheme,
  IconCheckButton,
  IconInfo,
  MessageBanner,
  theme,
  typographyRem,
} from '@by-miles/bymiles-styles'
import { useContext } from 'react'

import { useQuote } from '../../hooks/useQuote'
import { ProviderContext } from '../../Provider'
import { MilesTrackerStyle } from './MilesTrackerStyles'
import { shortManufacturerApp } from './utils'
const { paragraphBody: ParagraphBody, h5: H5 } = typographyRem

const getMessageBannerContent = (isTrackerLess: boolean, manufacturerApp: string) => {
  if (!isTrackerLess) {
    return (
      <span>
        You&apos;re covered by our comprehensive insurance from the second your policy starts. You can drive while you
        wait for your Miles Tracker to arrive.
      </span>
    )
  } else {
    return (
      <span>
        In a few simple steps, we’ll verify your vehicle and get consent to access your mileage data. That means there’s
        no need for any extra devices. Smart stuff.
      </span>
    )
  }
}

// const getConnectedCarHelpText = (manufacturerApp: string) => {
//   if (manufacturerApp === 'Driver by High Mobility') {
//     return (
//       <span>
//         Are you happy to use a <ManufacturerAppText manufacturerApp={manufacturerApp} /> account for us to talk to your
//         car? If you don't have one yet, you can set one up when we onboard you.
//       </span>
//     )
//   } else {
//     const app = shortManufacturerApp(manufacturerApp)
//     return (
//       <span>
//         You&apos;ll need {aOrAn(app)} {app} account for us to talk to your car.
//       </span>
//     )
//   }
// }

export const MilesTracker = () => {
  const quote = useQuote()
  const { state, handleShowModal } = useContext(ProviderContext)
  const vehicle = quote?.details?.vehicle
  const manufacturerApp = vehicle?.manufacturerApp || ''
  // const isConnectedCarEligible = vehicle?.connectedCar !== 'No'
  const isTrackerless = state.isTrackerless
  // * Switching OBD compatable to same design as uncompatible
  // const obdFit = vehicle?.obd_fit

  // const showToggle = isConnectedCarEligible && obdFit !== 'no' && obdFit !== 'unknown'

  // const handleConnectToggleClick = (hasConnectAccount: boolean) => {
  // DataLayer.customEvent({
  //   eventName: `toggle ${hasConnectAccount ? 'yes' : 'no'} account`,
  //   section: 'checkout how',
  //   eventType: 'form tracking',
  // })

  //   updateQuote({
  //     variables: {
  //       id: state.quoteId,
  //       actions: [
  //         {
  //           setConnectionType: {
  //             connectionType: hasConnectAccount ? ConnectionType.Odometer : ConnectionType.Obd,
  //           },
  //         },
  //       ],
  //     },
  //   })
  // }

  return (
    <MilesTrackerStyle hasByMilesTracker={!isTrackerless} make={vehicle?.make?.toLowerCase() || ''}>
      <div className="image-container" />

      <div className="copy-container LoNotSensitive">
        {/* {isConnectedCarEligible && manufacturerApp !== 'Tesla' && (
          <div className="connect-toggle-wrapper">
            <H5 className="title">{`Do you have ${aOrAn(shortManufacturerApp(manufacturerApp))} ${shortManufacturerApp(
              manufacturerApp,
            )} account for your ${vehicle?.make} ${vehicle?.model}?`}</H5>
            <ParagraphBody className="connect-p">{getConnectedCarHelpText(manufacturerApp)}</ParagraphBody>
            {showToggle && (
              // Replaced by SegmentedControl
              <YesNoToggle
                className="yes-no-toggle"
                onClick={handleConnectToggleClick}
                defaultSelection={isTrackerless}
              />
            )}
          </div>
        )} */}

        <div className="heading-icon-wrapper">
          <IconCheckButton
            status="complete"
            iconFill={theme.primaryColours.white.main}
            backgroundFill={theme.primaryColours.aubergine.main}
            buttonTheme={CheckButtonTheme.Dark}
          />
          <div>
            <H5>{`${isTrackerless ? 'Our Connect policy' : 'Our Miles Tracker'} is compatible with your ${quote?.details
              .vehicle.make!} ${quote?.details.vehicle.model!}.`}</H5>
            {/* {!isTrackerless && (
              // TODO * Replace when designs ready for different tracker instuctions
              <div className="helper-container">
                <ParagraphBody className="helper" style={{ color: theme.primaryColours.aubergine.main }}>
                  How do I plug it in?
                </ParagraphBody>
                <IconInfo
                  fill={theme.primaryColours.cyan.superDarkCyan}
                  stroke={theme.primaryColours.cyan.superDarkCyan}
                  onClick={() => handleShowModal('tracker-plugin')}
                />
              </div>
            )} */}
          </div>
        </div>

        {!isTrackerless && (
          <MessageBanner
            className="miles-tracker-info"
            text={getMessageBannerContent(isTrackerless, manufacturerApp || '')}
            backgroundColor={theme.tints.lightAubergine}
            borderColor={theme.primaryColours.aubergine.main}
            icon=""
          />
        )}

        {isTrackerless && (
          <div className="heading-icon-wrapper connect-header">
            <IconCheckButton
              status="complete"
              iconFill={theme.primaryColours.white.main}
              backgroundFill={theme.primaryColours.aubergine.main}
              buttonTheme={CheckButtonTheme.Dark}
            />
            <H5>{`Connecting By Miles to your free ${shortManufacturerApp(manufacturerApp)} account is easy.`}</H5>
            {!isTrackerless && (
              <div className="helper-container">
                <ParagraphBody className="helper" style={{ color: theme.primaryColours.aubergine.main }}>
                  Not your usual black box policy.
                </ParagraphBody>
                <IconInfo
                  fill={theme.primaryColours.cyan.superDarkCyan}
                  stroke={theme.primaryColours.cyan.superDarkCyan}
                  onClick={() => handleShowModal('driving-data')}
                />
              </div>
            )}
          </div>
        )}

        {isTrackerless && (
          <MessageBanner
            className="miles-tracker-info"
            text={getMessageBannerContent(isTrackerless, manufacturerApp || '')}
            backgroundColor={theme.tints.lightAubergine}
            borderColor={theme.primaryColours.aubergine.main}
            icon=""
          />
        )}

        <div className="heading-icon-wrapper">
          <IconCheckButton
            status="closed"
            iconFill={theme.primaryColours.white.main}
            backgroundFill={theme.primaryColours.aubergine.main}
            buttonTheme={CheckButtonTheme.Dark}
          />
          <div>
            <H5>We won't use data about your speed or driving style to change your price.</H5>
            {!isTrackerless && (
              <div className="helper-container">
                <ParagraphBody className="helper" style={{ color: theme.primaryColours.aubergine.main }}>
                  Not your usual black box policy.
                </ParagraphBody>
                <IconInfo
                  fill={theme.primaryColours.cyan.superDarkCyan}
                  stroke={theme.primaryColours.cyan.superDarkCyan}
                  onClick={() => handleShowModal('driving-data')}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </MilesTrackerStyle>
  )
}
